// /api: everything about the Bumpups API in one place. Overview (access, minutes, keys, recent API videos) and Docs.
import React from 'react';
import { NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AppTransition from '../components/appComponents/AppTransition';
import ApiOverview from './ApiOverview';
import ApiDocs from './ApiDocs';
import './apiPage.css';

const tabClass = ({ isActive }) => (isActive ? 'api-tab active' : 'api-tab');

export default function ApiPage() {
  const location = useLocation();
  return (
    <div className="api-page">
      <AppTransition>
        <Helmet>
          <meta name="description" content="Bumpups API keys, usage and docs." />
        </Helmet>
        <div className={`api-column${location.pathname.startsWith('/api/docs') ? ' api-column--wide' : ''}`}>
          <h1 className="api-title">API</h1>
          <nav className="api-tabs" aria-label="API sections">
            <NavLink to="/api" end className={tabClass}>Overview</NavLink>
            <NavLink to="/api/docs" className={tabClass}>Docs</NavLink>
          </nav>
          <Routes location={location}>
            <Route path="/" element={<ApiOverview />} />
            <Route path="docs" element={<ApiDocs />} />
            <Route path="*" element={<Navigate to="/api" replace />} />
          </Routes>
        </div>
      </AppTransition>
    </div>
  );
}
